import { ref } from "vue"
import useApi from "/@src/composable/useApi";
import { fetchKV, postKV } from "/@src/api/configRepo"
import _ from "lodash";

interface HotWordsResponse {
  auth?: string
  key: string
  name: string
  value?: HotWordItem[]
}
interface HotWordItem {
  title?: string
  link?: string
}
export default function useHotWords() {
  const result = ref<HotWordsResponse[] | []>([])
  const isLoading = ref(true)
  const hotWords = ref<string>('')
  const updateHotWords = ref()
  const raw = ref<HotWordsResponse[] | []>([])
  const isShowBtn = ref(false)
  const api = useApi()

  /**
   * 获取热搜词
   */
  const fetch = async() => {
    isLoading.value = false
    const ret = await fetchKV(api,'hot-search-words')
    result.value = ret.value as HotWordsResponse[]
    raw.value = _.cloneDeep(result.value)
  }

  /**
   * 更新热搜词
   */
  const update = (data:object):Promise<{}> => {
    return postKV(api,'hot-search-words','搜索热词',data)
  }

  /**
   * 新增热搜词（不保存至kv)
   */
  const addHotWords = () => {
    const newData = hotWords.value.split(' ').map((x) => {
      return { 
        title: x,
        link: ''
      } 
    }) as HotWordItem[]
    if (hotWords.value) {
      raw.value.unshift(...newData),
      updateHotWords.value = raw.value.map((x:HotWordItem) => x.title).join(',')
      isShowBtn.value = true
      hotWords.value = ''
    }
  }

  /**
   * 移除热搜词（不保存至kv)
   */
  const removeHotWords = (index: number) => {
    raw.value.splice(index, 1)
    updateHotWords.value = raw.value.map((x:HotWordItem) => x.title).join(',')
    hotWords.value = ''
    isShowBtn.value = true
  }

  const save = () => {
    isLoading.value = true
    update(raw.value).then((res) => {
      isShowBtn.value = false
      hotWords.value = ''
      isLoading.value = false
    })
  }

  return {
    fetch,
    addHotWords,
    removeHotWords,
    save,
    hotWords,
    updateHotWords,
    isLoading,
    isShowBtn,
    result,
    raw
  }
}
